// Static text, like /about: an address to write to is the same for everyone.
export const prerender = true;
